<template>
  <BannerBlock titleClass="">
    <template v-slot:title>{{$t("banner.missYouDesc")}}</template>
    <template v-slot:message>
      {{$t("banner.missYou")}}
    </template>
    <template v-slot:actions>
      <button class="btn btn-g-violet ">{{$t("generals.continue")}}</button>
    </template>
    <template v-slot:default>
      <!-- <img class="ml-auto" src="@/core/assets/Dashboard/Banner/miss-you.svg" /> -->
      <!-- <div class="bg"></div> -->
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/miss-you.svg')" />
      </div>
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../BannerBlock";
export default {
  name: "MissYou",
  components: {
    BannerBlock
  },
  data() {
    return {
      // dayLeft: 2
    };
  },
  computed: {
  }
};
</script>
<style lang="scss" scoped>
</style>
